var Curriculog = Curriculog || {};
Curriculog.util = (function (util, $, _) {
	/**
	 * dasherize("camelCasedString") -> 'camel-cased-string'
	 * @param  {String} camelCasedString
	 * @return {String}
	 */
	util.dasherize = function (camelCasedString) {
		var dashed = '',
			len = camelCasedString.length,
			i, c;
		for (i = 0; i < len; i++) {
			c = camelCasedString[i];
			if (c.match(/[A-Z]/) && i !== 0) {
				dashed += '-';
			}
			dashed += c.toLowerCase();
		}
		return dashed;
	};

	util.parseQueryString = function () {
		var keyvals = window.location.search.slice(1).split('&');
		return keyvals.reduce(function (result, item) {
			var keyval = item.split('=');
			result[keyval[0]] = decodeURIComponent(keyval[1]);
			return result;
		}, {});
	};

	util.escapeHTML = function (value) {
		var escapedValue = $('<div/>').text(value).html();
		return escapedValue;
	};

	util.capitalize = function (string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	util.truncator = function (length, ellipsis) {
		ellipsis = ellipsis || '';
		var maxLength = length - ellipsis.length;
		return function (string) {
			if (string.length > maxLength) {
				string = string.slice(0, maxLength) + ellipsis;
			}
			return string;
		};
	};

	util.truncate = function (string, length, ellipsis) {
		return util.truncator(length, ellipsis)(string);
	};

	return util;
}(Curriculog.util || {}, jQuery, _));
